import $ from 'jquery';

export default function menuItem() {
  $('.header .level-1.has-children').each(function () {
    $(this).click(function (e) {
      if ($(window).width() < 991) {
        e.preventDefault();
        $('.dropdown-menu').slideUp();

        if ($(this).next().hasClass('is-open')) {
          $(this).next().removeClass('is-open');
          $(this).next().next().slideUp();
        } else {
          $(this).next().addClass('is-open');
          $(this).next().next().slideDown();
        }
      }
    });
  });
}
